import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faFilePdf, faVideo } from "@fortawesome/free-solid-svg-icons";
import { Button, Modal } from "react-bootstrap";
// import Modal from "../common/Modal";
// import Modal from "../common/Modal";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Events = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [categoryname, setcategoryname] = useState("");
    const [categorytype, setcategorytype] = useState("Movie");
    const [categoryimage, setcategoryimage] = useState("");
    const [selectedid, setselectedid] = useState(0);

    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;

    const [articletype, setarticletype] = useState("");
    const [title, settitle] = useState("");
    const [description, setdescription] = useState("");
    const [minread, setminread] = useState("");
    const [image, setimage] = useState("");
    const [pdf, setpdf] = useState("");
    const [videourl, setvideourl] = useState("");





    const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    // console.log('obj >>', obj);
    setimage(obj);
  };

  const handleinputchange1 = async (file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    // console.log('obj >>', obj);
    setpdf(obj);
  };

  const submithandle = async () => {
    if (categoryname ) {
      setshowloding(true);
      var data = {
        title: categoryname,
        image: categoryimage,
        description: description
    };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "addnewstartupscreen", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            setshowmodal(false);
            setcategoryname("");
            setdescription("");
            setcategorytype("Movie");
            setcategoryimage("");
            fetchallcourses();
            setshowloding(false);
          } else {
            if(res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} })
              navigate('/admin/login');
            } else {
                alert(res.data.message);
            }
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      alert("Screen name is mandatory");
    }
  };

  const edithandle = async () => {
    
    console.log('selectedidRef.current >>', selectedidRef.current);
      if (categoryname ) {
        setshowloding(true);
        var data = {
          id: selectedidRef.current,
          title: categoryname,
          image: categoryimage,
          description: description
      };
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "updatestartupscreen", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              seteditshowmodal(false);
              setcategoryname("");
              setcategoryimage("");
              setdescription("");
              setselectedid(0);
              fetchallcourses();
              setshowloding(false);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
        setshowloding(false);
      } else {
        alert("Empty Field");
      }
    };

    const clickhandle = () =>  {
        // console.log('Mission Launched')
      }

      const editlocation = async(id, name, description) => {
        setselectedid(id);
        setcategoryname(name);
        setdescription(description)
        seteditshowmodal(true);
      }

      const defaultColDef = {
        flex: 1,
      };

      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm("Are you sure you want to disable this event ");
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updateeventstatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/admin/login');
        } else {
          alert(res.data.message);
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }

      const handledeletestory = async(id) => {
        // console.log('t >>', t.target.checked);
        const result = window.confirm("Are you sure you want to delete this event ");
          if(result) {

          } else {
            return
          }
        
          setshowloding(true);
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          var data = {
            'id': id
          }
          let resp = await axios
          .post(apiUrl + "deleteevent", data, headers)
          .then((res) => {
            if (res.data.status == "success") {
              fetchallcourses();
              setshowloding(false);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
          console.log('data >>', data);
      }


      const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "getallevents", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallarticles >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'pdfurl', 'videourl'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    obj.field = columns[i];
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }

                //Image
                if(columns.includes('image')) {
                  var imageobj = 
                  {
                    field: "Image",
                    headerName: "Image",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <Link
                        to={assetsUrl+'eventimages/'+props?.data?.image}
                        target="_blank"
                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                      >
                        <FontAwesomeIcon
                          icon={faEye}
                          className="sidebaricons"
                          style={{ color: "blue", fontSize: 15 }}
                        />
                      </Link>
                      )
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  }
                  columnsarr.push(imageobj);
                }

                //PDF
                if(columns.includes('pdfurl')) {
                  var imageobj = 
                  {
                    field: "PDF",
                    headerName: "PDF",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {
                            props?.data?.type == "PDF" ?
                            <Link
                        to={assetsUrl+'articlepdf/'+props?.data?.pdfurl}
                        target="_blank"
                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                      >
                        <FontAwesomeIcon
                          icon={faFilePdf}
                          className="sidebaricons"
                          style={{ color: "blue", fontSize: 15 }}
                        />
                      </Link> : null
                          }
                        </>
                        
                      )
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  }
                  columnsarr.push(imageobj);
                }

                //Video
                if(columns.includes('videourl')) {
                  var imageobj = 
                  {
                    field: "Video",
                    headerName: "Video",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {
                            props?.data?.type == "Video" ?
                            <Link
                        to={props?.data?.videourl}
                        target="_blank"
                        style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                      >
                        <FontAwesomeIcon
                          icon={faVideo}
                          className="sidebaricons"
                          style={{ color: "blue", fontSize: 15 }}
                        />
                      </Link> : null
                          }
                        </>
                        
                      )
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  }
                  columnsarr.push(imageobj);
                }


                //status
             var statusobj = {
              field: "status",
              maxWidth: 150,
              headerName: "Status",
              cellRenderer: (props) => {
                 // console.log('props >>', props?.data)
                 return (
                  <div className="d-flex">
                    <div class="form-check">
                      <input
                        onChange={(t) => {handleCheckboxChange(t, props?.data?.id)}}
                        type="checkbox"
                        class="form-check-input tableformcheck"
                        id="check1"
                        name="option1"
                        value="something"
                        checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
                      />
                    </div>
                  </div>
                );
              },
            };
            columnsarr.push(statusobj);

                

                //created_at
              //   if(columns.includes('created_at')) {
              //     var craetddatobj = 
              // {
              //   field: "Date",
              //   headerName: "Date",
              //   cellRenderer: (props) => {
              //     // console.log('date props >>', props);
              //     return (
              //            <div>
              //             <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
              //           </div>
              //     )
              //   },
              //   cellRendererParams: {
              //     onClick: clickhandle,
              //   },
              // }
              // columnsarr.push(craetddatobj);
              //   }
              
                //edit
                var editobj = 
                {
                  field: "edit",
                  maxWidth: 150,
                  headerName: "Edit",
                  cellRenderer: (props) => {
                    
                    return (
                      <div
                            onClick={() => {
                              // editlocation(props?.data?.id, props?.data?.title, props?.data?.description);
                              // console.log('props >>', props?.data);
                              navigate('/admin/edit-event/'+ props?.data?.id)
                            }}
                            style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                          >
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                              className="sidebaricons"
                              style={{ color: "blue", fontSize: 17 }}
                            />
                          </div>
                    )
                  },
                  cellRendererParams: {
                    onClick: clickhandle,
                  },
                }
                columnsarr.push(editobj);


                //delete
                var deleteobj = 
                {
                  field: "delete",
                  headerName: "Delete",
                  cellRenderer: (props) => {
                    
                    return (
                      <div
                            onClick={() => {
                              handledeletestory(props?.data?.id);
                              // console.log('props >>', props?.data);
                            }}
                            style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="sidebaricons"
                              style={{ color: "red", fontSize: 15 }}
                            />
                          </div>
                    )
                  },
                  cellRendererParams: {
                    onClick: clickhandle,
                  },
                }
                columnsarr.push(deleteobj);
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setRowData([]);
                setColDefs([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              // alert(res.data.message);
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
      };


    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/admin/login");
            }
          }, []);
    return (
      <div className="adminmainpagelayout">
        <div className="productstogglebar mt-2">
          <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              // setcategoryname("");
              // setdescription("");
              // setshowmodal(true);
              navigate('/admin/add-new-event');
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>New Event</p>
          </div>
        </div>

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 450, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/*Add modal */}
        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>New Article</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
            <div className="">
                <label className="addproduct-label">Article Type *</label>
                <select className="form-control addproductinput" value={articletype} onChange={(t) => {setarticletype(t.target.value)}}>
                   <option value={""} disabled selected>Select type</option>
                   <option value={"Text"}>Text</option>
                   <option value={"PDF"}>PDF</option>
                   <option value={"Video"}>Video</option>
                </select>
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Title *</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Title *"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Description</label>
                <textarea
                  value={description}
                  onChange={(t) => {
                    setdescription(t.target.value);
                  }}
                  className="form-control addproductinput"
                  style={{ height: 110 }}
                  placeholder="Enter Description"
                ></textarea>
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Minutes of Read</label>
                <input
                  value={minread}
                  onChange={(t) => {
                    setminread(t.target.value);
                  }}
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter Minutes"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Image *</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control addproductinput"
                  placeholder="Screen Image"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">PDF</label>
                <input
                  onChange={(t) => {
                    handleinputchange1(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control addproductinput"
                  placeholder=""
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Video Url</label>
                <input
                  value={videourl}
                  onChange={(t) => {
                    setvideourl(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Video URL"
                />
              </div>

              <div
                className="formsubmitbtn webadmin-modalbtn mt-4"
                onClick={() => {
                  submithandle();
                }}
              >
                <p>
                  {showloding ? (
                    <Spinner size={15} className="spinnerCenter" />
                  ) : (
                    "Submit"
                  )}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*Edit modal */}
        <Modal
          show={editshowmodal}
          onHide={() => seteditshowmodal(false)}
          size="md"
          className="custom-width-modal"
          title={"Edit Screen"}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Edit Screen</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="admin-label">Screen Name *</label>
                <input
                  value={categoryname}
                  onChange={(t) => {
                    setcategoryname(t.target.value);
                  }}
                  type="text"
                  className="form-control admininput"
                  placeholder="Enter Screen name *"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Description</label>
                <textarea
                  value={description}
                  onChange={(t) => {
                    setdescription(t.target.value);
                  }}
                  className="form-control addproductinput"
                  style={{ height: 110 }}
                  placeholder="Short Description"
                ></textarea>
              </div>
              <div className="mt-3">
                <label className="admin-label">Screen Image</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control admininput"
                  placeholder="Screen Image"
                />
              </div>

              <div
                className="formsubmitbtn webadmin-modalbtn mt-4"
                onClick={() => {
                  edithandle();
                }}
              >
                <p>
                  {showloding ? (
                    <Spinner size={15} className="spinnerCenter" />
                  ) : (
                    "Update"
                  )}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
}

export default Events